// Badge visual reutilizable para los 5 estados de validación JMA AFAC.
// Acepta tanto el label canónico ("Requiere ajuste") como una variante
// normalizada en kebab-case ("requiere-ajuste").

import { html } from 'htm/preact'

const LABEL_BY_KEY = {
  aprobado: 'Aprobado',
  pendiente: 'Pendiente',
  'requiere-ajuste': 'Requiere ajuste',
  bloqueado: 'Bloqueado',
  obsoleto: 'Obsoleto'
}

export function toCssKey(estado) {
  if (!estado) return ''
  return String(estado)
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/\s+/g, '-')
}

export function toLabel(estado) {
  if (!estado) return '—'
  const key = toCssKey(estado)
  return LABEL_BY_KEY[key] || estado
}

export function StatusBadge({ estado, size = 'md' }) {
  const key = toCssKey(estado)
  if (!key) {
    return html`<span class="badge badge--sin-estado">Sin estado</span>`
  }
  const sizeClass = size === 'sm' ? ' badge--sm' : ''
  return html`<span class=${`badge badge--${key}${sizeClass}`}>${toLabel(estado)}</span>`
}
